export const ImpersonationOrganisationSwitcher = () => {
  return null;
};